module.exports = __webpack_public_path__ + "static/media/sell_cancel_1.c8e738a8.jpg";